<script>
export default {
  name: 'FixedActionFooter',
}
</script>

<template>
  <v-footer
    height="57"
    style="border-top: 1px solid rgba(0, 0, 0, 0.12)"
    fixed
    inset
  >
    <slot></slot>
  </v-footer>
</template>
